
export const language = document.documentElement.lang || 'en'
